import React, { Component } from 'react';
import { Button, AnchorButton, Drawer, Position, Intent } from '@blueprintjs/core';
import Flexbox from 'flexbox-react';
import GuideContent from '../../static/GuideContent';
import renderHTML from 'react-render-html';
import Cookies from 'js-cookie';
import axios from 'axios';
import _ from 'lodash';
import { Icon } from '@blueprintjs/core';
import ToastStore from '../../stores/ToastStore';
import CurrentUserStore from '../../stores/CurrentUserStore';
import './GuideButton.css';
import MenuTiles from './MenuTiles';

export default class GuideButton extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showGuide: false,
            guide: null,
        };
    }

    componentDidMount() {
        const findGuide = _.find(GuideContent, o => o.action === this.props.action);
        if (findGuide) {
            this.setState({ guide: findGuide });
        }
    }

    toggleGuide() {
        this.setState({ showGuide: !this.state.showGuide });
    }


    async handleProProfsTrainingMakerLogin(event) {
        event.preventDefault();

        const baseUrl = Cookies.get('apiEnv');
        const loginUrl = `${baseUrl ? baseUrl.replace(/\/+$/, '') : ''}/tm_integrations/login_to_tm`;
        const currentUserEmail = CurrentUserStore.currentUser && CurrentUserStore.currentUser.email;

        try {
            const response = await axios.post(loginUrl, null, {
                params: { email: currentUserEmail },
            });
            const { status, url, message } = response && response.data ? response.data : {};

            if (status) {
                const redirectUrl = url || 'https://www.proprofstraining.com/app/?email={email}';
                window.open(redirectUrl, '_blank', 'noopener,noreferrer');
            } else {
                ToastStore.showToast(message || 'Failed to login to TM', 'danger');
            }
        } catch (error) {
            const errorMessage =
                error && error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : 'Failed to login to TM';
            ToastStore.showToast(errorMessage, 'danger');
        }
    }

    render() {
        const { guide, showGuide } = this.state;
        const darkMode = Cookies.get('theme') === 'dark' ? true : false;

        return (
            <Flexbox className="guide-button">

                {guide && (
                    <>
                        <Button
                            text={I18n.t('js.how_does_this_work')}
                            minimal={this.props.minimal}
                            outlined={!darkMode}
                            intent={darkMode ? Intent.WARNING : Intent.SUCCESS}
                            icon="manual"
                            onClick={() => this.toggleGuide()}
                        />
                        <Drawer
                            portalContainer={document.body}
                            position={Position.RIGHT}
                            onClose={this.toggleGuide.bind(this)}
                            isOpen={showGuide}
                            size={800}
                            title={guide.name}
                        >
                            <Flexbox flexDirection="column" padding="20px" style={{ overflowY: 'scroll' }}>
                                <Flexbox flexGrow={1} flexDirection="row" marginBottom="20px">
                                    <AnchorButton
                                        icon="document-open"
                                        intent={Intent.SUCCESS}
                                        text={I18n.t('js.learn_more_in_the_support_center')}
                                        href={guide.supportUrl}
                                        target="_blank"
                                        className="full-width"
                                    />
                                </Flexbox>
                                <p>{renderHTML(guide.content)}</p>
                            </Flexbox>
                        </Drawer>
                    </>
                )}
                {this.props.isHeader && (
                    <div className="proprofs-menu-wrapper">
                        <button
                            type="button"
                            className="proprofs-menu-trigger"
                            aria-label="Open ProProfs menu"
                        >
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle cx="6" cy="6" r="2" fill="#2E4A8F" />
                                <circle cx="12" cy="6" r="2" fill="#2E4A8F" />
                                <circle cx="18" cy="6" r="2" fill="#2E4A8F" />
                                <circle cx="6" cy="12" r="2" fill="#2E4A8F" />
                                <circle cx="12" cy="12" r="2" fill="#2E4A8F" />
                                <circle cx="18" cy="12" r="2" fill="#2E4A8F" />
                                <circle cx="6" cy="18" r="2" fill="#2E4A8F" />
                                <circle cx="12" cy="18" r="2" fill="#2E4A8F" />
                                <circle cx="18" cy="18" r="2" fill="#2E4A8F" />
                            </svg>
                        </button>
                        <div className="candy-box" data-test="true" aria-hidden="true" role="menu">
                            <MenuTiles onTrainingMakerLogin={this.handleProProfsTrainingMakerLogin.bind(this)} />
                        </div>
                    </div>
                )}
            </Flexbox>
        );
    }
}
